export * from './NewsModuleFeature';
